/**
 *
 * @module telemetryResponse
 *
 */

/**
 *
 * @class TelemetryResponse
 * @desc Model describing the response from the telemetry service
 * optionally containing both information and instructions.
 *
 */
export default class TelemetryResponse {

    /**
     *
     * @param {Number} replyAfter
     * @param {String} requestId
     *
     */
    constructor(replyAfter, requestId) {

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets the optional time to indicate the client should
         * back-off for a fixed time period before sending telemetry data.
         *
         */
        this.replyAfter = replyAfter;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets a unique tracking identifier for any API request.
         *
         */
        this.requestId = requestId;

    }

}



// WEBPACK FOOTER //
// ./src/services/internal/telemetry/telemetryResponse.js